var _path, _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "twitter_svg__a",
    width: 25,
    height: 20,
    x: 16,
    y: 18,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16 18h24.694v19.944H16V18Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#twitter_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#twitter_svg__b)",
    fillRule: "evenodd",
    d: "m38.161 22.962.017.652c0 6.656-5.094 14.33-14.413 14.33-2.861 0-5.523-.835-7.765-2.266.396.045.799.07 1.208.07 2.373 0 4.558-.804 6.292-2.153a5.065 5.065 0 0 1-4.732-3.498c.31.06.626.093.954.093.462 0 .911-.063 1.335-.176-2.317-.464-4.063-2.5-4.063-4.94v-.062a5.095 5.095 0 0 0 2.294.632 5.032 5.032 0 0 1-2.253-4.192c0-.924.249-1.789.686-2.532a14.403 14.403 0 0 0 10.44 5.263 5.044 5.044 0 0 1-.131-1.148c0-2.78 2.269-5.035 5.067-5.035 1.458 0 2.772.61 3.697 1.591a10.252 10.252 0 0 0 3.219-1.223 5.06 5.06 0 0 1-2.227 2.784c1.024-.12 2-.392 2.908-.793a10.078 10.078 0 0 1-2.533 2.603Z",
    clipRule: "evenodd"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    x: 0.5,
    y: 0.5,
    stroke: "#00CA72",
    rx: 27.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "twitter_svg__b",
    x1: 40.995,
    x2: 15.987,
    y1: 27.664,
    y2: 27.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CA72",
    stopOpacity: 0.2
  })))));
};
export default SvgTwitter;